export enum Visibility {
    PUBLIC = 'public',
    PRIVATE = 'private'
}
